"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5686],{

/***/ 67938:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ days_filter; }
});

// UNUSED EXPORTS: DaysFilter

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(2734);
// EXTERNAL MODULE: ./node_modules/@mui/material/Stack/Stack.js + 1 modules
var Stack = __webpack_require__(16216);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(36822);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/utility/luxon/index.ts
var luxon = __webpack_require__(90255);
// EXTERNAL MODULE: ./src/components/shared/muvi-tabs.tsx
var muvi_tabs = __webpack_require__(77044);
;// CONCATENATED MODULE: ./src/logic/helpers/check-is-prev-day.ts
function checkIsPrevDay(currentDate, prevDate) {
    return currentDate.getFullYear() === prevDate.getFullYear() && currentDate.getMonth() === prevDate.getMonth() && currentDate.getDate() > prevDate.getDate();
}

;// CONCATENATED MODULE: ./src/logic/helpers/check-is-same-days.ts
/**
 * Check if two dates are the same day.
 * @param {Date} d1 - Date - The first date to compare
 * @param {Date} d2 - Date - The date to compare to.
 * @returns the value of the variable x.
 */ function checkIsSameDays(d1, d2) {
    return d1.getFullYear() === d2.getFullYear() && d1.getMonth() === d2.getMonth() && d1.getDate() === d2.getDate();
}

// EXTERNAL MODULE: ./src/theme/typography.ts
var typography = __webpack_require__(43795);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(86896);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./src/components/movie-details/showtimes/days-filter.tsx



/* eslint-disable react-hooks/exhaustive-deps */ 







var DaysFilter = function(param) {
    var sessionsDate = param.sessionsDate, showTimeDate = param.showTimeDate, selectDate = param.selectDate, returnFirstEnabledDate = param.returnFirstEnabledDate;
    var theme = (0,useTheme/* default */.Z)();
    var intl = (0,useIntl/* default */.Z)();
    var locale = (0,router.useRouter)().locale;
    var ref = (0,react.useState)(false), activeTab = ref[0], setActiveTab = ref[1];
    (0,react.useEffect)(function() {
        if ((sessionsDate === null || sessionsDate === void 0 ? void 0 : sessionsDate.length) !== 0 && !showTimeDate) {
            var firstEnabledDate = sessionsDate[0];
            setActiveTab(0);
            returnFirstEnabledDate(firstEnabledDate);
        }
    }, [
        sessionsDate
    ]);
    (0,react.useEffect)(function() {
        if (showTimeDate) {
            var index = sessionsDate.findIndex(function(_session) {
                return _session.date === showTimeDate;
            });
            setActiveTab(index);
        }
    }, [
        showTimeDate,
        sessionsDate
    ]);
    var handleSessionFilterLabel = function(_session, index) {
        var todayShort;
        var userDate = new Date();
        if (checkIsPrevDay(userDate, new Date(_session === null || _session === void 0 ? void 0 : _session.date))) {
            todayShort = intl.formatMessage({
                id: "global.now"
            });
        } else if (checkIsSameDays(userDate, new Date(_session === null || _session === void 0 ? void 0 : _session.date)) && index === 0) {
            todayShort = intl.formatMessage({
                id: "today"
            });
        } else {
            todayShort = luxon/* DateTime.fromISO */.o.fromISO(_session === null || _session === void 0 ? void 0 : _session.date, {
                locale: locale
            }).weekdayShort;
        }
        var todayNumber = luxon/* DateTime.fromISO */.o.fromISO(_session.date, {
            locale: locale
        }).day;
        var monthShort = luxon/* DateTime.fromISO */.o.fromISO(_session.date, {
            locale: locale
        }).monthShort;
        var fontColor = index === activeTab ? theme.palette.common.white : theme.palette.grey[80];
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    component: "span",
                    sx: {
                        fontWeight: 400,
                        fontSize: (0,typography/* pxToRem */.Q)(12),
                        LineHeight: (0,typography/* pxToRem */.Q)(24),
                        color: fontColor,
                        textTransform: "none"
                    },
                    children: todayShort
                }),
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    component: "span",
                    sx: {
                        fontWeight: 900,
                        fontSize: (0,typography/* pxToRem */.Q)(16),
                        LineHeight: (0,typography/* pxToRem */.Q)(24),
                        color: fontColor
                    },
                    children: todayNumber
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    component: "span",
                    sx: {
                        fontWeight: 400,
                        fontSize: (0,typography/* pxToRem */.Q)(16),
                        LineHeight: (0,typography/* pxToRem */.Q)(24),
                        color: fontColor
                    },
                    children: monthShort
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(muvi_tabs/* default */.Z, {
        slideSx: {
            width: {
                mobile: "54px",
                tablet: (0,typography/* pxToRem */.Q)(69)
            }
        },
        swiperSx: {
            paddingX: (0,typography/* pxToRem */.Q)(30)
        },
        slideToClickedSlide: true,
        slidesPerGroupAuto: true,
        children: sessionsDate === null || sessionsDate === void 0 ? void 0 : sessionsDate.map(function(session, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                id: "movie-day-".concat(index),
                component: "button",
                sx: (0,_object_spread/* default */.Z)({
                    width: "100%",
                    minWidth: "unset",
                    height: "".concat((0,typography/* pxToRem */.Q)(92), " !important"),
                    background: theme.palette.lightGrey.main,
                    borderRadius: "10px",
                    border: "none",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    cursor: "pointer",
                    transition: "background-color 0.2s ease-in-out"
                }, activeTab === index && {
                    color: "".concat(theme.palette.common.white, " !important"),
                    backgroundColor: theme.palette.primary.main
                }),
                onClick: function() {
                    return selectDate(session.date);
                },
                children: handleSessionFilterLabel(session, index)
            }, session.date);
        })
    });
};
/* harmony default export */ var days_filter = (DaysFilter);


/***/ }),

/***/ 5929:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "V": function() { return /* binding */ MovieCollapseList; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(36822);
// EXTERNAL MODULE: ./node_modules/@mui/material/Fade/Fade.js
var Fade = __webpack_require__(16628);
// EXTERNAL MODULE: ./node_modules/react-infinite-scroll-component/dist/index.es.js
var index_es = __webpack_require__(58533);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(2734);
// EXTERNAL MODULE: ./node_modules/@mui/material/Accordion/Accordion.js + 1 modules
var Accordion = __webpack_require__(67358);
// EXTERNAL MODULE: ./node_modules/@mui/material/AccordionSummary/AccordionSummary.js + 1 modules
var AccordionSummary = __webpack_require__(38895);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/material/Stack/Stack.js + 1 modules
var Stack = __webpack_require__(16216);
// EXTERNAL MODULE: ./node_modules/@mui/material/AccordionDetails/AccordionDetails.js + 1 modules
var AccordionDetails = __webpack_require__(22797);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 2 modules
var Button = __webpack_require__(83321);
// EXTERNAL MODULE: ./node_modules/@mui/material/Divider/Divider.js
var Divider = __webpack_require__(67720);
// EXTERNAL MODULE: ./src/logic/services/movie-finder/index.ts + 2 modules
var movie_finder = __webpack_require__(87630);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/shared/customized-circular-progress.tsx
var customized_circular_progress = __webpack_require__(75491);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/ExpandMore.js
var ExpandMore = __webpack_require__(23508);
// EXTERNAL MODULE: ./src/components/experience/experience-card.tsx
var experience_card = __webpack_require__(69464);
// EXTERNAL MODULE: ./src/components/shared/icon-24.tsx
var icon_24 = __webpack_require__(97946);
// EXTERNAL MODULE: ./src/components/shared/image-box-future.tsx
var image_box_future = __webpack_require__(58718);
// EXTERNAL MODULE: ./src/theme/typography.ts
var typography = __webpack_require__(43795);
// EXTERNAL MODULE: ./src/logic/hooks/use-film-formatter.tsx
var use_film_formatter = __webpack_require__(95102);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(86896);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/components/offers/offer-badge.tsx + 1 modules
var offer_badge = __webpack_require__(50201);
// EXTERNAL MODULE: ./src/lotties/muvi_offer.json
var muvi_offer = __webpack_require__(45305);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(44012);
;// CONCATENATED MODULE: ./src/components/movie-details/showtimes/offer-tag.tsx





var showTimeOfferIcon = "/icons/shared/show-time-offer-icon.svg";
var OfferTag = function() {
    var theme = (0,useTheme/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
        direction: "row",
        sx: {
            p: "4px 8px",
            borderRadius: "20px",
            fontSize: {
                mobile: "14px",
                tablet: (0,typography/* pxToRem */.Q)(14)
            },
            backgroundColor: theme.palette.orange.light,
            width: "fit-content",
            mt: (0,typography/* pxToRem */.Q)(8)
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(image_box_future/* default */.Z, {
                img: showTimeOfferIcon,
                objectFit: "contain",
                sx: {
                    width: "16px",
                    height: "16px",
                    mr: (0,typography/* pxToRem */.Q)(8)
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                sx: {
                    fontSize: {
                        mobile: "14px",
                        tablet: (0,typography/* pxToRem */.Q)(14)
                    },
                    color: theme.palette.orange.main
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                    id: "offer.available"
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/logic/hooks/index.ts + 27 modules
var hooks = __webpack_require__(7663);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./src/components/shared/movie-collapse.tsx




















var TimeIcon = "/icons/movie-details/time.svg";
var pinIcon = "/icons/shared/location-icon-blue.svg";
var MovieCollapse = function(param) {
    var movie = param.movie, isExpanded = param.isExpanded, showExperiencesBy = param.showExperiencesBy, filters = param.filters, handleChange = param.handleChange, callOnFilmHasBeenStarted = param.callOnFilmHasBeenStarted, _showLoader = param.showLoader, showLoader = _showLoader === void 0 ? false : _showLoader, showTimeDate = param.showTimeDate;
    var ref, ref1;
    var theme = (0,useTheme/* default */.Z)();
    var intl = (0,useIntl/* default */.Z)();
    var ref2 = (0,react.useState)(movie.id), expandedMovie = ref2[0], setExpandedMovie = ref2[1];
    var ref3 = (0,react.useState)(null), updatedMovie = ref3[0], setUpdatedMovie = ref3[1];
    var ref4 = (0,hooks/* useCity */.hA)(), browserCityId = ref4.cityId;
    var router = (0,next_router.useRouter)();
    var cityId = +router.query.cityId || browserCityId;
    var ref5 = (0,use_film_formatter/* default */.Z)(movie), genresWithDots = ref5.genresWithDots, durationWithRateWithRtl = ref5.durationWithRateWithRtl, formattedDuration = ref5.formattedDuration;
    var ref6 = (0,movie_finder/* useGetFilmCinemas */.gY)({
        query: {
            id: expandedMovie
        },
        params: (0,_object_spread/* default */.Z)({}, filters)
    }, {
        enabled: false,
        onSuccess: function(filmCinemas) {
            setUpdatedMovie(function(prevValue) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevValue), {
                    cinemas: filmCinemas === null || filmCinemas === void 0 ? void 0 : filmCinemas.cinemas
                });
            });
        }
    }), refetch = ref6.refetch, isFetching = ref6.isFetching;
    (0,react.useEffect)(function() {
        setUpdatedMovie(movie);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        movie
    ]);
    (0,react.useEffect)(function() {
        isExpanded && !!showLoader && refetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        expandedMovie,
        isExpanded
    ]);
    return updatedMovie && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Accordion/* default */.Z, {
                expanded: isExpanded,
                onChange: function() {
                    handleChange();
                    setExpandedMovie(updatedMovie.id);
                },
                sx: {
                    mt: {
                        tablet: (0,typography/* pxToRem */.Q)(32),
                        mobile: "32px"
                    }
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionSummary/* default */.Z, {
                        expandIcon: isFetching && !!showLoader ? /*#__PURE__*/ (0,jsx_runtime.jsx)(customized_circular_progress/* default */.Z, {
                            size: 30
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandMore/* default */.Z, {
                            sx: {
                                color: theme.palette.grey[90]
                            }
                        }),
                        id: "movie-collapse-".concat(updatedMovie.id),
                        sx: {
                            display: "flex",
                            alignItems: "center",
                            backgroundColor: "transparent",
                            "& .MuiAccordionSummary-content": {
                                my: "0px !important"
                            },
                            "& .MuiAccordionSummary-content.Mui-expanded": {
                                mt: "15px !important"
                            }
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                            sx: {
                                display: "flex",
                                alignItems: "center"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                    sx: {
                                        position: "relative"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(image_box_future/* default */.Z, {
                                            img: movie === null || movie === void 0 ? void 0 : movie.image,
                                            title: movie === null || movie === void 0 ? void 0 : movie.title,
                                            layout: "intrinsic",
                                            objectFit: "cover",
                                            width: "1600px",
                                            height: "2400px",
                                            sx: {
                                                width: {
                                                    mobile: (0,typography/* pxToRem */.Q)(114),
                                                    tablet: (0,typography/* pxToRem */.Q)(136)
                                                },
                                                borderRadius: "20px",
                                                overflow: "hidden",
                                                boxShadow: "inset 0px 9px 30px rgba(0, 0, 0, 0.25)"
                                            }
                                        }),
                                        movie.rate && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            component: "span",
                                            sx: {
                                                color: updatedMovie.rate.fontColor,
                                                backgroundColor: updatedMovie.rate.backgroundColor,
                                                fontSize: (0,typography/* pxToRem */.Q)(10),
                                                position: "absolute",
                                                top: (0,typography/* pxToRem */.Q)(14),
                                                right: (0,typography/* pxToRem */.Q)(10),
                                                paddingX: (0,typography/* pxToRem */.Q)(8),
                                                paddingY: {
                                                    mobile: "2.5px",
                                                    mediumDesktop: "1px"
                                                },
                                                borderRadius: "20px"
                                            },
                                            children: updatedMovie.rate.title
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                    sx: {
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "space-between",
                                        marginInlineStart: (0,typography/* pxToRem */.Q)(28)
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            component: "h1",
                                            sx: {
                                                color: theme.palette.grey[80],
                                                fontWeight: 700,
                                                fontSize: {
                                                    tablet: (0,typography/* pxToRem */.Q)(28),
                                                    mobile: "18px"
                                                },
                                                lineHeight: {
                                                    tablet: (0,typography/* pxToRem */.Q)(32),
                                                    mobile: "24px"
                                                },
                                                marginTop: "10px",
                                                display: "-webkit-box",
                                                overflow: "hidden",
                                                WebkitLineClamp: "3",
                                                WebkitBoxOrient: "vertical"
                                            },
                                            children: updatedMovie.title
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                                                    direction: "row",
                                                    sx: {
                                                        marginTop: (0,typography/* pxToRem */.Q)(6),
                                                        color: theme.palette.grey[50],
                                                        alignItems: "center"
                                                    },
                                                    children: genresWithDots
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                                    sx: {
                                                        display: "flex",
                                                        alignItems: "center"
                                                    },
                                                    children: [
                                                        formattedDuration && /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_24/* default */.Z, {
                                                            icon: TimeIcon,
                                                            title: "alt.time_icon"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                            sx: {
                                                                fontSize: (0,typography/* pxToRem */.Q)(20),
                                                                color: theme.palette.grey[50],
                                                                lineHeight: "32px",
                                                                fontWeight: 400,
                                                                marginInlineStart: "8px"
                                                            },
                                                            children: durationWithRateWithRtl
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        (movie === null || movie === void 0 ? void 0 : movie.hasOffer) && /*#__PURE__*/ (0,jsx_runtime.jsx)(OfferTag, {})
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(AccordionDetails/* default */.Z, {
                        sx: {
                            maxWidth: (0,typography/* pxToRem */.Q)(700),
                            marginBottom: "20px"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                sx: {
                                    my: (0,typography/* pxToRem */.Q)(30),
                                    mx: (0,typography/* pxToRem */.Q)(16)
                                },
                                children: (movie === null || movie === void 0 ? void 0 : movie.hasOffer) && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: {
                                        pathname: "/movies/".concat(movie === null || movie === void 0 ? void 0 : movie.uniqueName, "/offers"),
                                        query: {
                                            date: showTimeDate,
                                            cityId: cityId
                                        }
                                    },
                                    passHref: true,
                                    prefetch: false,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        component: "a",
                                        sx: {
                                            width: "100%"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(offer_badge/* default */.Z, {
                                            lottie: muvi_offer,
                                            title: intl.formatMessage({
                                                id: "offer.showTime.title"
                                            }),
                                            subTitle: intl.formatMessage({
                                                id: "offer.showTime.subtitle"
                                            }),
                                            styles: {
                                                container: {
                                                    padding: "9px"
                                                },
                                                title: {
                                                    fontSize: {
                                                        mobile: "12px",
                                                        tablet: (0,typography/* pxToRem */.Q)(16)
                                                    }
                                                },
                                                subTitle: {
                                                    fontSize: {
                                                        mobile: "12px",
                                                        tablet: (0,typography/* pxToRem */.Q)(16)
                                                    },
                                                    color: theme.palette.grey[60]
                                                }
                                            }
                                        })
                                    })
                                })
                            }),
                            showExperiencesBy === "film" && ((ref = updatedMovie.experiances) === null || ref === void 0 ? void 0 : ref.map(function(experience, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                    sx: {
                                        margin: {
                                            mobile: "16px",
                                            tablet: (0,typography/* pxToRem */.Q)(16)
                                        }
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(experience_card/* ExperienceCard */.l, {
                                        movieId: updatedMovie.id,
                                        experience: experience,
                                        index: index,
                                        sxProps: {
                                            marginTop: 0
                                        },
                                        callOnFilmHasBeenStarted: callOnFilmHasBeenStarted
                                    })
                                }, experience.id);
                            })),
                            showExperiencesBy === "cinema" && ((ref1 = updatedMovie.cinemas) === null || ref1 === void 0 ? void 0 : ref1.map(function(param) {
                                var name = param.name, experiences = param.experiences, id = param.id;
                                /*#__PURE__*/ return (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                    sx: {
                                        margin: {
                                            mobile: "16px",
                                            tablet: "0px"
                                        }
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                            sx: {
                                                marginY: 3
                                            },
                                            direction: "row",
                                            alignItems: "center",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(image_box_future/* default */.Z, {
                                                    img: pinIcon,
                                                    title: intl.formatMessage({
                                                        id: "alt.pin_icon"
                                                    }),
                                                    objectFit: "contain",
                                                    sx: {
                                                        width: "14px",
                                                        height: "14px"
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    sx: {
                                                        fontSize: {
                                                            mobile: "18px",
                                                            tablet: (0,typography/* pxToRem */.Q)(20)
                                                        },
                                                        marginLeft: 2,
                                                        color: theme.palette.grey[80]
                                                    },
                                                    children: name
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                            children: experiences === null || experiences === void 0 ? void 0 : experiences.map(function(experience, index) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(experience_card/* ExperienceCard */.l, {
                                                        movieId: updatedMovie.id,
                                                        experience: experience,
                                                        index: index
                                                    })
                                                }, experience.id);
                                            })
                                        })
                                    ]
                                }, id);
                            }))
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                sx: {
                    mt: {
                        tablet: (0,typography/* pxToRem */.Q)(24),
                        mobile: "24px"
                    },
                    mr: (0,typography/* pxToRem */.Q)(10),
                    ml: (0,typography/* pxToRem */.Q)(35)
                }
            })
        ]
    });
};
/* harmony default export */ var movie_collapse = (MovieCollapse);

// EXTERNAL MODULE: ./node_modules/@alpha.apps/react-common/dist/index.js + 6 modules
var dist = __webpack_require__(46080);
// EXTERNAL MODULE: ./src/components/shared/movie-loader-wrapper.tsx + 1 modules
var movie_loader_wrapper = __webpack_require__(75884);
;// CONCATENATED MODULE: ./src/components/shared/movie-collapse-list.tsx










var MovieCollapseList = function(param) {
    var movies = param.movies, hasMore = param.hasMore, filters = param.filters, fetchMovies = param.fetchMovies, showExperiencesBy = param.showExperiencesBy, isFetching = param.isFetching, isFetchingNextPage = param.isFetchingNextPage, _infiniteScrollProps = param.infiniteScrollProps, infiniteScrollProps = _infiniteScrollProps === void 0 ? {} : _infiniteScrollProps, showLoader = param.showLoader, callOnFilmHasBeenStarted = param.callOnFilmHasBeenStarted, showTimeDate = param.showTimeDate;
    var ref = (0,react.useState)(null), activeAccordion = ref[0], setExpanded = ref[1];
    var handleChange = function(panelNumber) {
        return function() {
            if (activeAccordion === panelNumber) setExpanded(null);
            else setExpanded(panelNumber);
        };
    };
    // useEffect(() => {
    //   setExpanded(0);
    //   // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [movies]);
    (0,react.useEffect)(function() {
        if ((0,dist/* isString */.HD)(showTimeDate)) {
            setExpanded(null);
        }
    }, [
        showTimeDate
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: (movies === null || movies === void 0 ? void 0 : movies.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            dataLength: movies.length,
            next: fetchMovies,
            hasMore: hasMore,
            loader: hasMore && isFetchingNextPage && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                sx: {
                    display: "flex",
                    justifyContent: "center",
                    p: 5
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(customized_circular_progress/* default */.Z, {
                    size: 40,
                    thickness: 4
                })
            }),
            style: {
                overflow: "unset"
            }
        }, infiniteScrollProps), {
            children: movies === null || movies === void 0 ? void 0 : movies.map(function(movie, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Fade/* default */.Z, {
                    appear: true,
                    in: true,
                    timeout: 300,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(movie_collapse, {
                            movie: movie,
                            filters: filters,
                            isExpanded: activeAccordion === index,
                            handleChange: handleChange(index),
                            showExperiencesBy: showExperiencesBy,
                            showLoader: showLoader,
                            callOnFilmHasBeenStarted: callOnFilmHasBeenStarted,
                            showTimeDate: showTimeDate
                        })
                    })
                }, movie.id);
            })
        })) : isFetching && /*#__PURE__*/ (0,jsx_runtime.jsx)(movie_loader_wrapper/* MovieLoaderWrapper */.Y, {
            innerBox: {
                width: "100%",
                height: "160px",
                marginTop: "50px",
                display: "flex",
                justifyContent: "center"
            }
        })
    });
};


/***/ }),

/***/ 75884:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Y": function() { return /* binding */ MovieLoaderWrapper; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(36822);
// EXTERNAL MODULE: ./src/components/shared/lottie-player.tsx
var lottie_player = __webpack_require__(71192);
;// CONCATENATED MODULE: ./src/lotties/movieLoader.json
var movieLoader_namespaceObject = JSON.parse('{"nm":"Comp 1","mn":"","layers":[{"ty":3,"nm":"Null 1","mn":"","sr":1,"st":0,"op":120,"ip":0,"hd":false,"cl":"","ln":"","ddd":0,"bm":0,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6},"sk":{"a":0,"k":0},"p":{"a":0,"k":[960,540,0],"ix":2},"sa":{"a":0,"k":0},"o":{"a":0,"k":0,"ix":11},"r":{"a":1,"k":[{"o":{"x":0.333,"y":0},"i":{"x":0.294,"y":1},"s":[0],"t":0},{"o":{"x":0.655,"y":0},"i":{"x":0.667,"y":1},"s":[360],"t":60},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[720],"t":117.5}],"ix":10}},"ef":[],"ind":1},{"ty":4,"nm":"Ellipse 4","mn":"","sr":1,"st":0,"op":120,"ip":0,"hd":false,"cl":"","ln":"","ddd":0,"bm":0,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6},"sk":{"a":0,"k":0},"p":{"a":1,"k":[{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[0,0,0],"t":0},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[-134,134,0],"t":60},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[0,0,0],"t":117.5}],"ix":2},"sa":{"a":0,"k":0},"o":{"a":1,"k":[{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[80],"t":0},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[100],"t":60},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[80],"t":117.5}],"ix":11},"r":{"a":0,"k":0,"ix":10}},"ef":[],"shapes":[{"ty":"gr","bm":0,"cl":"","ln":"","hd":false,"mn":"ADBE Vector Group","nm":"Ellipse 4 Stroke","ix":1,"cix":2,"np":3,"it":[{"ty":"el","bm":0,"cl":"","ln":"","hd":false,"mn":"ADBE Vector Shape - Ellipse","nm":"Ellipse Path 1","d":1,"p":{"a":0,"k":[0,0],"ix":3},"s":{"a":0,"k":[118,118],"ix":2}},{"ty":"op","bm":0,"cl":"","ln":"","hd":false,"mn":"ADBE Vector Filter - Offset","nm":"Offset Paths 1","ix":3,"a":{"a":0,"k":-0.5,"ix":1},"lj":1,"ml":{"a":0,"k":4,"ix":3}},{"ty":"tr","a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"sk":{"a":0,"k":0,"ix":4},"p":{"a":0,"k":[0,0],"ix":2},"r":{"a":0,"k":0,"ix":6},"sa":{"a":0,"k":0,"ix":5},"o":{"a":0,"k":100,"ix":7}}]},{"ty":"gr","bm":0,"cl":"","ln":"","hd":false,"mn":"ADBE Vector Group","nm":"Ellipse 4 Fill","ix":2,"cix":2,"np":2,"it":[{"ty":"el","bm":0,"cl":"","ln":"","hd":false,"mn":"ADBE Vector Shape - Ellipse","nm":"Ellipse Path 1","d":1,"p":{"a":0,"k":[0,0],"ix":3},"s":{"a":0,"k":[118,118],"ix":2}},{"ty":"fl","bm":0,"cl":"","ln":"","hd":false,"mn":"ADBE Vector Graphic - Fill","nm":"Fill 1","c":{"a":0,"k":[0.8196,0.6667,0.8431],"ix":4},"r":1,"o":{"a":0,"k":100,"ix":5}},{"ty":"tr","a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"sk":{"a":0,"k":0,"ix":4},"p":{"a":0,"k":[0,0],"ix":2},"r":{"a":0,"k":0,"ix":6},"sa":{"a":0,"k":0,"ix":5},"o":{"a":0,"k":100,"ix":7}}]}],"ind":2,"parent":1},{"ty":4,"nm":"Ellipse 3","mn":"","sr":1,"st":0,"op":120,"ip":0,"hd":false,"cl":"","ln":"","ddd":0,"bm":0,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6},"sk":{"a":0,"k":0},"p":{"a":1,"k":[{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[0,0,0],"t":0},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[134,134,0],"t":60},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[0,0,0],"t":117.5}],"ix":2},"sa":{"a":0,"k":0},"o":{"a":1,"k":[{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[80],"t":0},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[100],"t":60},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[80],"t":117.5}],"ix":11},"r":{"a":0,"k":0,"ix":10}},"ef":[],"shapes":[{"ty":"gr","bm":0,"cl":"","ln":"","hd":false,"mn":"ADBE Vector Group","nm":"Ellipse 3 Stroke","ix":1,"cix":2,"np":3,"it":[{"ty":"el","bm":0,"cl":"","ln":"","hd":false,"mn":"ADBE Vector Shape - Ellipse","nm":"Ellipse Path 1","d":1,"p":{"a":0,"k":[0,0],"ix":3},"s":{"a":0,"k":[118,118],"ix":2}},{"ty":"op","bm":0,"cl":"","ln":"","hd":false,"mn":"ADBE Vector Filter - Offset","nm":"Offset Paths 1","ix":3,"a":{"a":0,"k":-0.5,"ix":1},"lj":1,"ml":{"a":0,"k":4,"ix":3}},{"ty":"tr","a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"sk":{"a":0,"k":0,"ix":4},"p":{"a":0,"k":[0,0],"ix":2},"r":{"a":0,"k":0,"ix":6},"sa":{"a":0,"k":0,"ix":5},"o":{"a":0,"k":100,"ix":7}}]},{"ty":"gr","bm":0,"cl":"","ln":"","hd":false,"mn":"ADBE Vector Group","nm":"Ellipse 3 Fill","ix":2,"cix":2,"np":2,"it":[{"ty":"el","bm":0,"cl":"","ln":"","hd":false,"mn":"ADBE Vector Shape - Ellipse","nm":"Ellipse Path 1","d":1,"p":{"a":0,"k":[0,0],"ix":3},"s":{"a":0,"k":[118,118],"ix":2}},{"ty":"fl","bm":0,"cl":"","ln":"","hd":false,"mn":"ADBE Vector Graphic - Fill","nm":"Fill 1","c":{"a":0,"k":[0.549,0.1725,0.6078],"ix":4},"r":1,"o":{"a":0,"k":100,"ix":5}},{"ty":"tr","a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"sk":{"a":0,"k":0,"ix":4},"p":{"a":0,"k":[0,0],"ix":2},"r":{"a":0,"k":0,"ix":6},"sa":{"a":0,"k":0,"ix":5},"o":{"a":0,"k":100,"ix":7}}]}],"ind":3,"parent":1},{"ty":4,"nm":"Ellipse 2","mn":"","sr":1,"st":0,"op":120,"ip":0,"hd":false,"cl":"","ln":"","ddd":0,"bm":0,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6},"sk":{"a":0,"k":0},"p":{"a":1,"k":[{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[0,0,0],"t":0},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[134,-134,0],"t":60},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[0,0,0],"t":117.5}],"ix":2},"sa":{"a":0,"k":0},"o":{"a":1,"k":[{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[80],"t":0},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[100],"t":60},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[80],"t":117.5}],"ix":11},"r":{"a":0,"k":0,"ix":10}},"ef":[],"shapes":[{"ty":"gr","bm":0,"cl":"","ln":"","hd":false,"mn":"ADBE Vector Group","nm":"Ellipse 2 Stroke","ix":1,"cix":2,"np":3,"it":[{"ty":"el","bm":0,"cl":"","ln":"","hd":false,"mn":"ADBE Vector Shape - Ellipse","nm":"Ellipse Path 1","d":1,"p":{"a":0,"k":[0,0],"ix":3},"s":{"a":0,"k":[118,118],"ix":2}},{"ty":"op","bm":0,"cl":"","ln":"","hd":false,"mn":"ADBE Vector Filter - Offset","nm":"Offset Paths 1","ix":3,"a":{"a":0,"k":-0.5,"ix":1},"lj":1,"ml":{"a":0,"k":4,"ix":3}},{"ty":"tr","a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"sk":{"a":0,"k":0,"ix":4},"p":{"a":0,"k":[0,0],"ix":2},"r":{"a":0,"k":0,"ix":6},"sa":{"a":0,"k":0,"ix":5},"o":{"a":0,"k":100,"ix":7}}]},{"ty":"gr","bm":0,"cl":"","ln":"","hd":false,"mn":"ADBE Vector Group","nm":"Ellipse 2 Fill","ix":2,"cix":2,"np":2,"it":[{"ty":"el","bm":0,"cl":"","ln":"","hd":false,"mn":"ADBE Vector Shape - Ellipse","nm":"Ellipse Path 1","d":1,"p":{"a":0,"k":[0,0],"ix":3},"s":{"a":0,"k":[118,118],"ix":2}},{"ty":"fl","bm":0,"cl":"","ln":"","hd":false,"mn":"ADBE Vector Graphic - Fill","nm":"Fill 1","c":{"a":0,"k":[0.7333,0.502,0.7686],"ix":4},"r":1,"o":{"a":0,"k":100,"ix":5}},{"ty":"tr","a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"sk":{"a":0,"k":0,"ix":4},"p":{"a":0,"k":[0,0],"ix":2},"r":{"a":0,"k":0,"ix":6},"sa":{"a":0,"k":0,"ix":5},"o":{"a":0,"k":100,"ix":7}}]}],"ind":4,"parent":1},{"ty":4,"nm":"Ellipse 1","mn":"","sr":1,"st":0,"op":120,"ip":0,"hd":false,"cl":"","ln":"","ddd":0,"bm":0,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6},"sk":{"a":0,"k":0},"p":{"a":1,"k":[{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[0,0,0],"t":0},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[-134,-134,0],"t":60},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[0,0,0],"t":117.5}],"ix":2},"sa":{"a":0,"k":0},"o":{"a":1,"k":[{"o":{"x":0.333,"y":0},"i":{"x":0.188,"y":1},"s":[80],"t":0},{"o":{"x":0.899,"y":-0.919},"i":{"x":0.667,"y":1},"s":[100],"t":60},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[80],"t":117.5}],"ix":11},"r":{"a":0,"k":0,"ix":10}},"ef":[],"shapes":[{"ty":"gr","bm":0,"cl":"","ln":"","hd":false,"mn":"ADBE Vector Group","nm":"Ellipse 1 Stroke","ix":1,"cix":2,"np":3,"it":[{"ty":"el","bm":0,"cl":"","ln":"","hd":false,"mn":"ADBE Vector Shape - Ellipse","nm":"Ellipse Path 1","d":1,"p":{"a":0,"k":[0,0],"ix":3},"s":{"a":0,"k":[118,118],"ix":2}},{"ty":"op","bm":0,"cl":"","ln":"","hd":false,"mn":"ADBE Vector Filter - Offset","nm":"Offset Paths 1","ix":3,"a":{"a":0,"k":-0.5,"ix":1},"lj":1,"ml":{"a":0,"k":4,"ix":3}},{"ty":"tr","a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"sk":{"a":0,"k":0,"ix":4},"p":{"a":0,"k":[0,0],"ix":2},"r":{"a":0,"k":0,"ix":6},"sa":{"a":0,"k":0,"ix":5},"o":{"a":0,"k":100,"ix":7}}]},{"ty":"gr","bm":0,"cl":"","ln":"","hd":false,"mn":"ADBE Vector Group","nm":"Ellipse 1 Fill","ix":2,"cix":2,"np":2,"it":[{"ty":"el","bm":0,"cl":"","ln":"","hd":false,"mn":"ADBE Vector Shape - Ellipse","nm":"Ellipse Path 1","d":1,"p":{"a":0,"k":[0,0],"ix":3},"s":{"a":0,"k":[118,118],"ix":2}},{"ty":"fl","bm":0,"cl":"","ln":"","hd":false,"mn":"ADBE Vector Graphic - Fill","nm":"Fill 1","c":{"a":0,"k":[0.549,0.1725,0.6078],"ix":4},"r":1,"o":{"a":0,"k":100,"ix":5}},{"ty":"tr","a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"sk":{"a":0,"k":0,"ix":4},"p":{"a":0,"k":[0,0],"ix":2},"r":{"a":0,"k":0,"ix":6},"sa":{"a":0,"k":0,"ix":5},"o":{"a":0,"k":100,"ix":7}}]}],"ind":5,"parent":1}],"ddd":0,"h":1080,"w":1920,"meta":{"a":"","k":"","d":"","g":"LottieFiles AE 1.1.0","tc":"#000000"},"v":"4.8.0","fr":60,"op":120,"ip":0,"assets":[]}');
;// CONCATENATED MODULE: ./src/components/shared/movie-loader-wrapper.tsx




var MovieLoaderWrapper = function(param) {
    var innerBox = param.innerBox, outerBox = param.outerBox;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        sx: outerBox,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lottie_player/* LottiePlayer */.V, {
            animationData: movieLoader_namespaceObject,
            boxSx: innerBox
        })
    });
};


/***/ })

}]);